<template>
  <div
    :class="{'gc-navigator-bottom-bar__link--active': active }"
    class="gc-navigator-bottom-bar__link gc-navigator-bottom-bar__link--menu"
    @click="clicked()">

    <div class="gc-navigator-bottom-bar__icon">

      <icon-hamburger-filled
        v-if="active"
        :size="'md1'"
        class="gc-navigator-bottom-bar__link-icon gc-navigator-bottom-bar__link-icon--active"/>
      <icon-hamburger-filled
        v-else
        :size="'md1'"
        class="gc-navigator-bottom-bar__link-icon"/>
      <icon-ellipse
        v-if="hasNewFeature"
        size="sm1"/>
      <icon-underline/>
    </div>
  </div>
</template>
<script>
import IconHamburgerFilled from '../../../root/icons/IconHamburgerFilled'
import IconHamburgerLinear from '../../../root/icons/IconHamburgerLinear'
import IconDot from '../../../root/icons/IconDot'
import IconEllipse from '../../../root/icons/IconEllipse'
import IconUnderline from '@/components/root/icons/IconUnderline.vue'

export default {
  name: 'NavigatorBottomBarLinkMenu',
  components: {
    IconUnderline,
    IconEllipse,
    IconDot,
    IconHamburgerFilled,
    IconHamburgerLinear
  },
  props: {
    hasNewFeature: {
      default: false
    },
    active: {
      default: false
    }
  },
  methods: {
    clicked () {
      this.$emit('click')
    }
  }
}
</script>
